import { render, staticRenderFns } from "./RoomTypeDetailModal.vue?vue&type=template&id=0f6116f7&scoped=true&"
import script from "./RoomTypeDetailModal.vue?vue&type=script&lang=js&"
export * from "./RoomTypeDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./RoomTypeDetailModal.vue?vue&type=style&index=0&id=0f6116f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6116f7",
  null
  
)

export default component.exports